import { Fragment } from "react"

import style from "modules/PsyProfile/components/Info/components/Titles/style.module.scss"
import { psychologistTitles } from "utils/helpers/psychologistUtil"
import { capitalize } from "utils/utils"
import { Psychologist } from "utils/interfaces"
import { Text } from "ui-kit/components-branded/Text"

export const Titles = ({ psy }: { psy: Psychologist }) => {
    const titles = psychologistTitles(psy)

    return (
        <div className={style.container}>
            {titles.map((title, index) => (
                <Fragment key={title}>
                    <Text>{capitalize(title)}</Text>
                    {index < titles.length - 1 && (
                        <div className={style.dots}>
                            <div className={style.dotsInner} />
                        </div>
                    )}
                </Fragment>
            ))}
        </div>
    )
}
